/* 🤖 this file was generated by svg-to-ts */
export const siriusArrowFatLinesRight: {
  name: 'arrow_fat_lines_right';
  data: string;
} = {
  name: 'arrow_fat_lines_right',
  data: `<svg fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" style="display: block;"><path d="m22.28 11.47-9-9A.75.75 0 0 0 12 3v3.75H9.75A.75.75 0 0 0 9 7.5v9a.75.75 0 0 0 .75.75H12V21a.75.75 0 0 0 1.28.53l9-9a.747.747 0 0 0 0-1.06Zm-8.78 7.72V16.5a.75.75 0 0 0-.75-.75H10.5v-7.5h2.25a.75.75 0 0 0 .75-.75V4.81L20.69 12l-7.19 7.19ZM4.5 7.5v9a.75.75 0 1 1-1.5 0v-9a.75.75 0 0 1 1.5 0Zm3 0v9a.75.75 0 1 1-1.5 0v-9a.75.75 0 0 1 1.5 0Z" fill="currentColor"/></svg>`
};
